import { jsx as E } from "react/jsx-runtime";
import { BadRequest as M } from "@systemeio/util";
import { useStore as P } from "../../../../store/index.mjs";
import { stripeCardBuyOffer as S, confirmPaymentIntent as x } from "../../api/stripe-api.mjs";
import { getStripeCardConfirmHandler as b } from "../utils/get-stripe-card-confirm-handler.mjs";
import { useStripe as g, useElements as k, ExpressCheckoutElement as q } from "../../../../node_modules/@stripe/react-stripe-js/dist/react-stripe.esm.mjs";
import { PaymentMethodEnum as B } from "@systemeio/ui";
import { useRollbar as F } from "@rollbar/react";
function T({
  setIsFetching: a,
  handleBadRequest: f,
  setErrors: c,
  preSubmit: l
}) {
  const r = g(), t = k(), y = F(), { locale: d } = P();
  return /* @__PURE__ */ E(
    q,
    {
      options: {
        paymentMethods: {
          applePay: "always",
          googlePay: "never",
          amazonPay: "never",
          link: "never",
          paypal: "never"
        }
      },
      onConfirm: async (o) => {
        if (!(!r || !t)) {
          a(!0);
          try {
            const e = l();
            if (!e) return;
            const { error: u } = await t.submit();
            if (u) {
              o.paymentFailed();
              return;
            }
            const { error: h, paymentMethod: n } = await r.createPaymentMethod({
              elements: t
            });
            if (h || !n) {
              o.paymentFailed();
              return;
            }
            const { redirect: i, intentSecret: m, intentType: w } = await S(
              {
                ...e,
                paymentMethod: B.stripe_applepay,
                options: { stripePaymentMethodId: n.id }
              },
              d
            );
            if (!m) return window.location.href = i;
            const C = b(r, w), { error: s } = await C(m, {
              payment_method: n.id
            });
            s ? c((p) => ({
              ...p,
              common: [...p.common, s.message]
            })) : (await x(), window.location.assign(i));
          } catch (e) {
            try {
              o.paymentFailed({ reason: "fail" });
            } catch {
            }
            e instanceof M ? f(e) : y.error("Stripe Express Checkout Confirmation Error", { error: e });
          } finally {
            a(!1);
          }
        }
      }
    }
  );
}
export {
  T as StripeExpressCheckout
};
